import { createAction } from 'redux-actions';
import { PapiDaSharedOriginalsOrder, PapiDeviation } from '@wix/da-papi-types';
import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';
import { OriginalStatusType } from '../../types/originals';

export type ChangeOriginalStatusPayload = {
  deviation: PapiDeviation;
  status: OriginalStatusType;
};

export const changeOriginalStatus = createAction(
  '@@ORIGINALS.CHANGE_STATUS',
  (payload: ChangeOriginalStatusPayload) => payload
);

export const changeOriginalStatusSuccess = createAction(
  '@@ORIGINALS.CHANGE_STATUS_SUCCESS',
  (payload: PapiDeviation) => payload
);

export const toggleOriginalStatus = createAction(
  '@@ORIGINALS.TOGGLE_STATUS',
  (payload: PapiDeviation) => payload
);

export const fetchOriginalsOrderDetails = createAction(
  '@@ORIGINALS.FETCH_ORDER_DETAILS',
  (payload: {
    deviationId: number;
    responseId: number;
    onSuccess: (order: PapiDaSharedOriginalsOrder) => void;
    onError: (error: Error) => void;
  }) => payload
);

export const declineOriginalOrder = createAction(
  '@@ORIGINALS.DECLINE_ORDER',
  (payload: {
    deviationId: number;
    responseId: number;
    reason: string;
    onSuccess: () => void;
    onError: (error: Error) => void;
  }) => payload
);

export const acceptOriginalOrder = createAction(
  '@@ORIGINALS.ACCEPT_ORDER',
  (payload: {
    deviationId: number;
    responseId: number;
    onSuccess: () => void;
    onError: (error: Error) => void;
  }) => payload
);

export const fetchNextOrders = createCallbackActionCreator(
  '@@ORIGINALS.FETCH_NEXT_ORDERS'
);
